<ng-container *transloco="let tr; prefix: 'promoBanners'; scope: 'promo-banners'">
  <nz-affix [nzOffsetTop]="0">
    <hx-breadcrumbs></hx-breadcrumbs>
    <nz-page-header nzBackIcon [nzGhost]="false">
      <nz-page-header-title>{{'promoBanners.title' | transloco}}</nz-page-header-title>
    </nz-page-header>
  </nz-affix>

  <nz-skeleton [nzActive]="true" [nzLoading]="isLoading.model">
    <form nz-form class="hx-form" [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()">
      <div nz-row [nzGutter]="8">
        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{tr('form.name')}}</nz-form-label>
            <nz-form-control>
              <input nz-input formControlName="name"/>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{tr('form.enabled')}}</nz-form-label>
            <nz-form-control>
              <nz-radio-group formControlName="enabled">
                <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
                <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row [nzGutter]="8">
        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{tr('form.mainBanner')}}</nz-form-label>
            <nz-form-control>
              <nz-radio-group formControlName="mainBanner">
                <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
                <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{tr('form.banner')}}</nz-form-label>
            <nz-form-control>
              <nz-radio-group formControlName="banner">
                <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
                <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{tr('form.promo')}}</nz-form-label>
            <nz-form-control>
              <nz-radio-group formControlName="promo">
                <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
                <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row [nzGutter]="8">
        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{tr('form.startDate')}}</nz-form-label>
            <nz-form-control>
              <nz-date-picker formControlName="startDate" nzFormat="yyyy-MM-dd"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col>
          <nz-form-item>
            <nz-form-label>{{tr('form.endDate')}}</nz-form-label>
            <nz-form-control>
              <nz-date-picker formControlName="endDate" nzFormat="yyyy-MM-dd"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col>
          <nz-form-item>
            <nz-form-label>{{tr('form.sortOrder')}}</nz-form-label>
            <nz-form-control>
              <nz-input-number formControlName="sortOrder" [nzMin]="1" [nzMax]="1000" [nzStep]="1"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row [nzGutter]="8">
        <div nz-col class="hx-col-2">
          <nz-form-item>
            <nz-form-label nzRequired>{{tr('form.title')}}</nz-form-label>
            <nz-form-control>
              <hx-label-edit formControlName="title"></hx-label-edit>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row [nzGutter]="8">
        <div nz-col class="hx-col-2">
          <nz-form-item>
            <nz-form-label nzRequired>{{tr('form.description')}}</nz-form-label>
            <nz-form-control>
              <hx-label-edit [type]="'textarea'" formControlName="description"></hx-label-edit>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row [nzGutter]="8">
        <div nz-col class="hx-col-4">
          <nz-form-item>
            <nz-form-label nzRequired>{{tr('form.cityIds')}}</nz-form-label>
            <nz-form-control>
              <hx-city-select [hxMode]="'multiple'" (selectChange)="onCityChanged($event)" formControlName="cityIds"></hx-city-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <nz-divider nzDashed="true" [nzText]="tr('stories')" nzOrientation="left"></nz-divider>

      <button (click)="addStory()" nz-button type="button" class="m-bot-1rem">{{'button.addNew' | transloco}}</button>

      <nz-table [nzData]="stories" [nzPageSize]="100">
        <thead>
        <tr>
          <th>{{tr('story.th.url')}}</th>
          <th>{{tr('story.th.type')}}</th>
          <th>{{tr('story.th.lang')}}</th>
          <th>{{tr('story.th.action')}}</th>
          <th>#</th>
        </tr>
        </thead>
        <tbody cdkDropList (cdkDropListDropped)="drop($event)">
        <tr cdkDrag *ngFor="let data of stories; let ix = index">
          <td>{{data.url}}</td>
          <td>{{data.type}}</td>
          <td>{{data.lang}}</td>
          <td>
            @if (data.action) {
              {{ data.action.button | json }} {{ data.action.url }}
            }
          </td>
          <td>
            <nz-button-group>
              <button (click)="editStory(data, ix)" nz-button nzType="primary" type="button">
                <i nz-icon nzType="edit" nzTheme="outline"></i>
              </button>
              <button nz-button nzType="default" nzDanger nz-popconfirm type="button"
                      [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                      [nzCancelText]="'no1' | transloco"
                      (nzOnConfirm)="removeStory(data, ix)">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </button>
            </nz-button-group>
          </td>
        </tr>
        </tbody>
      </nz-table>

      <nz-alert *ngIf="isCreate" nzType="info" [nzMessage]="tr('files.notification.enabledAfterSaving')" nzShowIcon></nz-alert>

      <ng-container *ngIf="isEdit">
        <nz-divider nzDashed="true" [nzText]="tr('files.attachments')" nzOrientation="left"></nz-divider>
        <div nz-row [nzGutter]="8" class="files-container">
          <div nz-col [nzSpan]="24">
            <nz-skeleton [nzActive]="true" *ngIf="isLoading.files"></nz-skeleton>
            <div class="clearfix" *ngIf="!isLoading.files">
              <nz-upload
                nzListType="picture"
                class="upload-list-inline"
                [(nzFileList)]="fileList"
                [nzAction]="filesUploadUrl"
                [nzMultiple]="true"
                [nzRemove]="fileRemoveFn"
                [nzHeaders]="fileUploadHeadersFn"
                (nzChange)="handleFileUploadStatusChanged($event, 'files')"
                [nzPreview]="handlePreviewFn">
                <button nz-button type="button">
                  <span><i nz-icon nzType="upload"></i> {{'button.upload' | transloco}}</span>
                </button>
              </nz-upload>
              <nz-modal [nzVisible]="preview.visible" [nzTitle]="preview.fileName" [nzWidth]="'initial'" [nzContent]="modalContent" [nzFooter]="null"
                        (nzOnCancel)="preview = {}">
                <ng-template #modalContent>
                  <div nz-row>
                    <nz-col [nzSpan]="24">
                      <input nz-input type="text" readonly [value]="preview.link">
                    </nz-col>
                  </div>
                  <nz-divider></nz-divider>
                  <div nz-row *ngIf="preview.fileName">
                    <div *ngIf="!preview.fileName.endsWith('.md')" nz-col [nzSpan]="24" style="text-align: center">
                      <img [src]="preview.image"/>
                    </div>
                    <div *ngIf="preview.fileName.endsWith('.md') && preview.data" nz-col [nzSpan]="24">
                      <markdown [data]="preview.data"></markdown>
                    </div>
                  </div>
                </ng-template>
              </nz-modal>
            </div>
          </div>
        </div>

        <div nz-row [nzGutter]="8" class="files-flag-container">
          <div nz-col [nzSpan]="24">
            <nz-tag *ngFor="let rf of requiredFiles" [nzColor]="rf.exist ? 'success': 'warning'">
              <i nz-icon [nzType]="rf.exist ? 'check-circle' : 'exclamation-circle'"></i>
              <span>{{rf.fileName}}</span>
            </nz-tag>
          </div>
        </div>
      </ng-container>

      <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

      <div nz-row [nzGutter]="8" class="cp_actions">
        <div nz-col>
          <nz-form-item>
            <nz-form-control>
              <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button nzType="primary">
                <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
              </button>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col>
          <nz-tag nzColor="success" *ngIf="form.pristine && model?.id">
            <i nz-icon nzType="check-circle"></i>
            <span>{{'form.saved' | transloco}}</span>
          </nz-tag>
        </div>
      </div>
    </form>
  </nz-skeleton>
</ng-container>
